export default "__VITE_ASSET__DuVISP_C__"